import Prism from 'prismjs';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-php.js';
import 'prismjs/components/prism-go.js';
import 'prismjs/components/prism-java.js';
import 'prismjs/components/prism-kotlin.js';
import 'prismjs/components/prism-swift.js';
import 'prismjs/components/prism-php.js';

Prism.languages.insertBefore(
  'javascript',
  'string',
  {
    'md-link': {
      pattern: /\[([^\]]+)]\(([^)]+)\)/,
      greedy: true,
    },
  },
  null
);
